import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa } from '../shared';
import { ApiResponseModel } from '../shared/api-response.model';
import { Observable } from 'rxjs';

// /core2/platform/dm/iam/app-login/process/execute/demo_staging/login-tenant-ep

@Injectable({
  providedIn: 'root'
})
export class AppLoginRootToTenantSyncService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + 'app-login/process/execute';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + 'app-login/process/execute';
    this.httpClient = http;
  }
  
  getHttpHeader(apiVisa: ApiVisa): { headers: HttpHeaders } {
    return {
      headers: new HttpHeaders({
        'visa': apiVisa.jwt_secret,         // or AccessKey depending on backend
        'Authorization': `Bearer ${apiVisa.jwt_secret}`,
        'Content-Type': 'application/json'
      })
    };
  }

  synchData(tenantCode: string, apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (apiVisa && apiVisa.api_domain_url != null) {
      this.apiUrl = apiVisa.api_domain_url +  this.endpoint_path
    }
    const url = this.apiUrl + `/${tenantCode}/login-tenant-ep`;
    const headers = this.getHttpHeader(apiVisa).headers;

    return this.httpClient.request<ApiResponseModel<any>>(
      'GET',
      url,
      {
        body: {},           // empty JSON body to satisfy Spring
        headers: headers,   // pass HttpHeaders directly
        responseType: 'json' as const, // force TS type
        observe: 'body'
      }
    );
  }
}
